const routes = {
  auth: `/auth/*`,
  authSignup: `/auth/signup`,
  authSignin: `/auth/signin`,
  resetPassword: `/auth/reset-password`,
  dashboard: `/dashboard/*`,
  dashboardNavigation: `/dashboard`,
  report: "/report",
  carEstimate: "/car-estimate",
  upcomingCarsBuyNow: "/upcoming-cars-buy-now",
  upcomingCars: "/upcoming-cars",
  buyNow: "/buy-now",
  liveAuction: "/live-auction",
  carsInNegotiation: "/cars-in-negotiation",
  carsInNegotiationBuyNow: "/cars-in-negotiation-buy-now",
  myGarage: "/my-garage",
  watchList: "/watch-list",
  myOrders: "/my-orders",
  profile: "/profile"
};

export {
  routes
};